// Development configuration (local backend)
export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const API_SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

// Production configuration (uncomment when deploying)
// export const API_BASE_URL = 'https://api.seednation.com/api';
// export const API_SOCKET_URL = 'https://api.seednation.com';

// Stripe configuration
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'pk_test_51QpEUGG8evvzQwuJIcuwbYrNn94Bmk4iakdmdywniMlZq72FEnUewiRtiMB6ekRiSQSYM5aBL7xB0UKQuGwyMdta002rvOuEoD';

// App configuration
export const APP_CONFIG = {
    defaultPageSize: 20,
    maxFileSize: 16 * 1024 * 1024, // 16MB
    supportedImageFormats: ['png', 'jpg', 'jpeg', 'gif', 'webp'],
    supportedDocumentFormats: ['pdf', 'doc', 'docx', 'txt', 'csv', 'xlsx']
};
